import { render, staticRenderFns } from "./writeComment.vue?vue&type=template&id=02133189&scoped=true&"
import script from "./writeComment.vue?vue&type=script&lang=js&"
export * from "./writeComment.vue?vue&type=script&lang=js&"
import style0 from "./writeComment.vue?vue&type=style&index=0&id=02133189&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02133189",
  null
  
)

export default component.exports